"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const CardSharedStyles_module_scss_1 = __importDefault(require("./CardSharedStyles.module.scss"));
const md_1 = require("react-icons/md");
const react_router_dom_1 = require("react-router-dom");
const react_i18next_1 = require("react-i18next");
const feed_factory_models_lang_1 = require("@feed-factory/feed-factory.models.lang");
const feed_factory_media_preview_1 = __importDefault(require("@feed-factory/feed-factory.media-preview"));
const go_1 = require("react-icons/go");
const ai_1 = require("react-icons/ai");
const date_fns_1 = require("date-fns");
const feed_factory_helpers_1 = require("@feed-factory/feed-factory.helpers");
const LocationCard = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    const { t } = (0, react_i18next_1.useTranslation)();
    const entry = props.entry;
    const [comments, setComments] = (0, react_1.useState)([]);
    // Check if preferred language is available. If not: show primary language of item.
    let trcItemDetails = null;
    if (((_b = (_a = entry.translations) === null || _a === void 0 ? void 0 : _a.availableLanguages) === null || _b === void 0 ? void 0 : _b.find((avLang) => avLang === props.lang)) &&
        entry.trcItemDetails[props.lang]) {
        trcItemDetails = entry.trcItemDetails[props.lang];
    }
    else if ((_c = entry.translations) === null || _c === void 0 ? void 0 : _c.primaryLanguage) {
        trcItemDetails = entry.trcItemDetails[(_d = entry.translations) === null || _d === void 0 ? void 0 : _d.primaryLanguage];
    }
    // Get comments of item
    (0, react_1.useEffect)(() => {
        if (props.minimalDisplay) {
            return;
        }
        if (!props.entry.id) {
            return;
        }
        const commentUrl = `${(0, feed_factory_helpers_1.generateItemApiUrl)("LOCATIE", props.entry.id)}/comments`;
        feed_factory_helpers_1.feedFactoryAxios.get(commentUrl).then((response) => {
            setComments(response.data);
        });
    }, [props.entry.id]);
    const card = (react_1.default.createElement("div", { className: [
            CardSharedStyles_module_scss_1.default.Card,
            CardSharedStyles_module_scss_1.default.hoverable,
            entry.wfstatus === "approved" ? CardSharedStyles_module_scss_1.default.published : "",
            entry.wfstatus === "deleted" ? CardSharedStyles_module_scss_1.default.deleted : "",
            entry.wfstatus === "archived" ? CardSharedStyles_module_scss_1.default.archived : "",
            props.active ? CardSharedStyles_module_scss_1.default.active : "",
        ].join(" ") },
        react_1.default.createElement("div", { className: CardSharedStyles_module_scss_1.default.image },
            react_1.default.createElement(feed_factory_media_preview_1.default, { mediaItem: (_e = entry.files) === null || _e === void 0 ? void 0 : _e[0], coverView: true })),
        react_1.default.createElement("div", { className: CardSharedStyles_module_scss_1.default.content },
            entry.userorganisation &&
                props.userorganisations.length > 0 &&
                !props.userorganisations.find((org) => org === entry.userorganisation) && (react_1.default.createElement("div", { className: CardSharedStyles_module_scss_1.default.otherOwner },
                react_1.default.createElement("span", null,
                    react_1.default.createElement(ai_1.AiFillCrown, null),
                    " "),
                react_1.default.createElement("span", null, entry.userorganisation))),
            react_1.default.createElement("h2", { className: CardSharedStyles_module_scss_1.default.selectable }, (trcItemDetails === null || trcItemDetails === void 0 ? void 0 : trcItemDetails.title) || react_1.default.createElement("em", null, t("location.noNameAvailable"))),
            !props.minimalDisplay && (react_1.default.createElement("div", { className: CardSharedStyles_module_scss_1.default.langDisplay }, (_g = (_f = entry.translations) === null || _f === void 0 ? void 0 : _f.availableLanguages) === null || _g === void 0 ? void 0 : _g.map((lang) => {
                var _a;
                if (!((_a = feed_factory_models_lang_1.langMetadata === null || feed_factory_models_lang_1.langMetadata === void 0 ? void 0 : feed_factory_models_lang_1.langMetadata[lang]) === null || _a === void 0 ? void 0 : _a.flag)) {
                    return null;
                }
                return react_1.default.createElement(feed_factory_helpers_1.Twemoji, { key: lang }, feed_factory_models_lang_1.langMetadata[lang].flag);
            }))),
            ((_j = (_h = entry.location) === null || _h === void 0 ? void 0 : _h.address) === null || _j === void 0 ? void 0 : _j.city) && (react_1.default.createElement("div", { className: [CardSharedStyles_module_scss_1.default.badge, CardSharedStyles_module_scss_1.default.city].join(" ") },
                react_1.default.createElement(md_1.MdPlace, null),
                " ", (_l = (_k = entry.location) === null || _k === void 0 ? void 0 : _k.address) === null || _l === void 0 ? void 0 :
                _l.city)), (_o = (_m = entry.trcItemCategories) === null || _m === void 0 ? void 0 : _m.types) === null || _o === void 0 ? void 0 :
            _o.slice(0, 4).map((cat) => {
                return (react_1.default.createElement("div", { key: cat.catid, className: [CardSharedStyles_module_scss_1.default.badge, CardSharedStyles_module_scss_1.default.category].join(" ") },
                    react_1.default.createElement(go_1.GoPrimitiveDot, null),
                    " ",
                    (0, feed_factory_helpers_1.getCategoryById)(cat.catid)));
            }),
            ((_p = entry.trcItemCategories) === null || _p === void 0 ? void 0 : _p.types) &&
                ((_q = entry.trcItemCategories) === null || _q === void 0 ? void 0 : _q.types.length) > 4 && (react_1.default.createElement("div", { className: [
                    CardSharedStyles_module_scss_1.default.badge,
                    CardSharedStyles_module_scss_1.default.category,
                    CardSharedStyles_module_scss_1.default.moreCategories,
                ].join(" ") },
                react_1.default.createElement(md_1.MdMoreHoriz, null))),
            (trcItemDetails === null || trcItemDetails === void 0 ? void 0 : trcItemDetails.shortdescription) &&
                ((_r = trcItemDetails === null || trcItemDetails === void 0 ? void 0 : trcItemDetails.shortdescription) === null || _r === void 0 ? void 0 : _r.length) > 0 ? (react_1.default.createElement("p", { className: CardSharedStyles_module_scss_1.default.selectable }, trcItemDetails.shortdescription.length < 128
                ? trcItemDetails.shortdescription
                : `${trcItemDetails.shortdescription.substr(0, 128)}...`)) : (react_1.default.createElement("p", null,
                react_1.default.createElement("em", null, t("event.noDescriptionAvailable")))),
            !props.minimalDisplay && (react_1.default.createElement("div", { className: CardSharedStyles_module_scss_1.default.cardFooter },
                entry.lastupdated && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("span", null,
                        t("root.lastupdated"),
                        ": "),
                    (0, date_fns_1.format)(new Date(entry.lastupdated), "yyyy-MM-dd HH:mm"))),
                entry.creationdate && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("br", null),
                    react_1.default.createElement("span", null,
                        t("root.creationdate"),
                        ": "),
                    (0, date_fns_1.format)(new Date(entry.creationdate), "yyyy-MM-dd HH:mm")))))),
        comments && comments.length > 0 && (react_1.default.createElement("div", { className: CardSharedStyles_module_scss_1.default.comment, title: comments.map((c) => c.body).join(" //") },
            react_1.default.createElement(md_1.MdComment, null),
            " ",
            (0, feed_factory_helpers_1.trimComment)(comments[0].body)))));
    if (!props.locationUrl) {
        return react_1.default.createElement("div", { className: `noStyle ${props.className || ""}` }, card);
    }
    else {
        return (react_1.default.createElement(react_router_dom_1.Link, { to: props.locationUrl, className: `noStyle ${props.className || ""}`, target: props.openInNewTab ? "_target" : "_self" }, card));
    }
};
exports.default = LocationCard;
//# sourceMappingURL=LocationCard.js.map